/* eslint-disable */
import {
  assertBoolean,
  attributeSwitchComponent,
  memoEval,
  multilingualTextValueComponent,
} from '@salsita-ai/platform-project-sdk/domain'

import { attachAdminComponent } from '../admin-implementation.js'

export const presetCategoryComponents = [
  attachAdminComponent
    .withComponent(multilingualTextValueComponent, 'name', true)
    .withEntity('PresetCategory')
    .attach(
      memoEval(
        // @ts-ignore
        self =>
          // keep deps on a separate line so @ts-ignore only covers the parameter
          [self.name],
        name => ({
          value: name,
        })
      ),
      state => {
        return { name: state.value }
      }
    ),

  attachAdminComponent
    .withComponent(multilingualTextValueComponent, 'description', true)
    .withEntity('PresetCategory')
    .attach(
      memoEval(
        // @ts-ignore
        self =>
          // keep deps on a separate line so @ts-ignore only covers the parameter
          [self.description],
        description => ({
          value: description,
        })
      ),
      state => {
        return { description: state.value }
      }
    ),

  attachAdminComponent
    .withComponent(attributeSwitchComponent, 'visible', true)
    .withEntity('PresetCategory')
    .attach(
      memoEval(
        // @ts-ignore
        self =>
          // keep deps on a separate line so @ts-ignore only covers the parameter
          [self.visible],
        visible => ({
          value: visible,
        })
      ),
      state => {
        assertBoolean(state.value)
        return { visible: state.value }
      }
    ),
]
